import { render, staticRenderFns } from "./investigation-case.vue?vue&type=template&id=3f9923de&scoped=true"
import script from "./investigation-case.vue?vue&type=script&lang=ts"
export * from "./investigation-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9923de",
  null
  
)

export default component.exports